import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29246_1287)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.1665 8.02005C16.1665 3.59298 12.5825 0 8.1665 0C3.7505 0 0.166504 3.59298 0.166504 8.02005C0.166504 11.9018 2.9185 15.1338 6.5665 15.8797V10.4261H4.9665V8.02005H6.5665V6.01504C6.5665 4.46717 7.8225 3.20802 9.3665 3.20802H11.3665V5.61404H9.7665C9.3265 5.61404 8.9665 5.97494 8.9665 6.41604V8.02005H11.3665V10.4261H8.9665V16C13.0065 15.599 16.1665 12.1825 16.1665 8.02005Z",
			fill: "#3B5998"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29246_1287",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.166504)"
		})
	}) })]
});
export default SvgFacebook;
